export default "__VITE_ASSET__BFJE_6Vm__"